export type ScoreTier = 'high' | 'mid' | 'low' | 'none';

export const scoreTier = (score: number | null | undefined): ScoreTier =>
  score == null ? 'none' : score >= 80 ? 'high' : score >= 60 ? 'mid' : 'low';

export interface ScoreBreakdown {
  comp: number;
  explanation?: string;
  logistics: number;
  roleFit: number;
  techMatch: number;
}

const formatAmount = (amount: number) =>
  amount < 1000 ? `$${amount}` : `$${Math.round(amount / 1000)}k`;

export const formatSalary = (
  min: number | null | undefined,
  max: number | null | undefined,
) => {
  const hasMin = min !== null && min !== undefined;
  const hasMax = max !== null && max !== undefined;
  if (hasMin && hasMax) return `${formatAmount(min)}–${formatAmount(max)}`;
  if (hasMin) return formatAmount(min);
  if (hasMax) return formatAmount(max);
  return null;
};
